package com.tixforgigs.common.core.enums

enum class DeviceClass {
  MOBILE,
  TABLET,
  DESKTOP,
  ULTRAWIDE_DEVICE,
}
